import { Fotter } from '../../../../components';

import styles from './index.module.css';

import n1 from './images/1.png'
import n2 from './images/2.png'
import n3 from './images/3.png'
import n4 from './images/4.png'
import n5 from './images/5.png'
import n6 from './images/6.png'
import n7 from './images/7.png'
import n8 from './images/8.png'
import c1 from './images/c1.png'
import c2 from './images/c2.png'
import c3 from './images/c3.png'
import c4 from './images/c4.png'
import c5 from './images/c5.png'
import c6 from './images/c6.png'
import c7 from './images/c7.png'
import c8 from './images/c8.png'
import { useState } from 'react';

const text = {
    cn: {
        title: '合作伙伴',
    },
    en: {
        title: 'OUR PARTNER'
    },
}

const images = [
    [[n1, c1], [n2, c2]],
    [[n3, c3], [n4, c4]],
    [[n5, c5], [n6, c6]],
    [[n7, c7], [n8, c8]],
]

const CooperativePartner = (props) => {
    const { l } = props;
    const [hover, setHover] = useState([]);
    return (
        <div className={styles['page']}>
            <div className={styles['title']}>{text[l]['title']}</div>
            <div className={styles['card-box']}>
                {images.map((item, index) => (
                    <>
                        <div className={styles['card']}>
                            {item.map((src, i) => (
                                <>
                                    <div className={styles['img-box']}>
                                        <img
                                            src={(hover[0] === index && hover[1] === i) ? src[1] : src[0]}
                                            className={styles['img']}
                                            onMouseEnter={() => {
                                                setHover([index, i]);
                                            }}
                                            onMouseLeave={() => {
                                                setHover([]);
                                            }}
                                            alt=''
                                        />
                                    </div>
                                    {i !== item.length - 1 && (
                                        <div style={{ height: 50 }}></div>
                                    )}
                                </>
                            ))}
                        </div>
                        {index !== images.length - 1 && (
                            <div className={styles['line']}>&nbsp;</div>
                        )}
                    </>
                ))}
            </div>
            <div className={styles['footer']}>
                <Fotter l={l} />
            </div>
        </div>
    )
}

export default CooperativePartner;